import { CSSProperties, ReactNode } from "react";

interface TooltipProps {
  text: string;
  children: ReactNode;
  className?: string;
  tooltipClassName?: string;
  tooltipStyle?: CSSProperties;
}

const Tooltip = ({
  text,
  children,
  className = "",
  tooltipClassName = "",
  tooltipStyle,
}: TooltipProps) => (
  <span className={`relative inline-flex group ${className}`}>
    {children}
    <span
      className={`pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 rounded bg-gray-800 px-2 py-1 text-xs text-white shadow-sm opacity-0 transition-opacity duration-150 group-hover:opacity-100 z-50 whitespace-nowrap ${tooltipClassName}`}
      style={tooltipStyle}
    >
      {text}
    </span>
  </span>
);

export default Tooltip;
